








import { defineComponent } from '@vue/composition-api';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';

export default defineComponent({
  name: 'AuthNgFailView',
  components: {
    AppRow,
    AppText,
    AppLink,
  },

  setup() {
    return {
      NG_REASON_DETAIL_URL: process.env.VUE_APP_NP_ATOBARAI_SETTLEMENT_ERROR_DETAIL_URL,
    };
  },
});
